import { createApi } from "@reduxjs/toolkit/query/react";
import {
  AdvertisementBannerDetailResponse,
  AdvertisementBannerResponse,
  CineBannersResponse,
  CineSettingResponseData,
  QueryParams,
} from "types/api";
import { axiosBaseQuery } from "@picovico/helpers";

export const miscApi = createApi({
  baseQuery: axiosBaseQuery(),
  tagTypes: ["Misc"],
  reducerPath: "misc",
  endpoints: (builder) => ({
    getBanners: builder.query<CineBannersResponse, QueryParams>({
      query: (queryData) => ({
        name: "banner",
        method: "GET",
        params: {
          ...queryData,
        },
      }),
    }),
    getAdvertisemnetBanners: builder.query<
      AdvertisementBannerResponse,
      QueryParams
    >({
      query: (queryData) => ({
        name: "advertisement-banner",
        method: "GET",
        params: {
          ...queryData,
          paginate: false,
        },
      }),
      providesTags: ["Misc"],
    }),
    getAdvertisemnetBannerDetail: builder.query<
      AdvertisementBannerDetailResponse,
      QueryParams
    >({
      query: ({ idx, params }) => ({
        name: "advertisement-detail",
        method: "GET",
        idx,
        params,
      }),
      providesTags: ["Misc"],
    }),
    getCineSetting: builder.query<CineSettingResponseData, QueryParams>({
      query: (queryData) => ({
        name: "cine_setting",
        method: "GET",
        ...queryData,
      }),
    }),
  }),
});

export const {
  useGetBannersQuery,
  useGetAdvertisemnetBannersQuery,
  useLazyGetAdvertisemnetBannersQuery,
  useGetAdvertisemnetBannerDetailQuery,
  useLazyGetBannersQuery,
  useGetCineSettingQuery,
  useLazyGetCineSettingQuery,
} = miscApi;
